<template>
  <div class="regulatory-update-announcement-pj">
    <HelperViewContextual
      title="Atualize seu cadastro"
      description="Solicite a atualização enviando um e-mail para cadastro@warren.com.br"
      icon="AA0040"
      :context="helperViewContext"
    />
    <Message class="regulatory-update-announcement-pj__disclaimer">
      <template #description>
        A atualização é obrigatória conforme as normas da Comissão de Valores
        Mobiliários, Instrução 617.
      </template>
    </Message>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import {
  HelperViewContextual,
  MessageFoundation as Message
} from '@warrenbrasil/nebraska-web';
import { isWarrenManaged } from '@/modules/common/services/partner';

@Component({
  components: {
    HelperViewContextual,
    Message
  }
})
export default class RegulatoryUpdateAnnouncementPJ extends Vue {
  public get helperViewContext(): string {
    if (isWarrenManaged()) {
      return 'brand';
    }
    return 'neutral';
  }
}
</script>

<style lang="less" scoped>
.regulatory-update-announcement-pj {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: @size-spacing-x600;
  padding: @size-spacing-x400;

  &__disclaimer {
    max-width: 436px;
  }
}
</style>
